export function setPageHeading(title: string) {
		return <h1 style={{display:'none'}}>{title}</h1>
}


// WEBPACK FOOTER //
// ./src/common/fragments/PageHeading.tsx